export enum CameraMode {
    preview,
    captured,
    editing,
    forceCaptureConfirm,
}

export interface ViewfinderProps extends React.HTMLAttributes<HTMLDivElement> {
    $levelOk?: boolean;
    $oriEnabled?: boolean;
}
